/**
 * Represents the active PTIN status of a provider.
 */
export enum ProviderActivePtinStatusDto {
  NotApplicable = 'NOT_APPLICABLE',
  Inactive = 'INACTIVE',
  Active = 'ACTIVE',
}
